import { render, staticRenderFns } from "./PlayerFullscreenPublic.vue?vue&type=template&id=156e4a90&scoped=true&"
import script from "./PlayerFullscreenPublic.vue?vue&type=script&lang=js&"
export * from "./PlayerFullscreenPublic.vue?vue&type=script&lang=js&"
import style0 from "./PlayerFullscreenPublic.vue?vue&type=style&index=0&id=156e4a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e4a90",
  null
  
)

export default component.exports